<template>
  <div class="columns">
    <div class="column is-12">
      <div id="analog-clock" :style="clockStyles">
        <div
          id="hour"
          v-if="!clock.is_hour_hidden"
          :style="`transform: rotate(${hourDegrees}deg)`"
        ></div>
        <div
          id="minute"
          v-if="!clock.is_minute_hidden"
          :style="`transform: rotate(${minuteDegrees}deg)`"
        ></div>
        <div
          id="second"
          v-if="!clock.is_second_hidden"
          :style="`transform: rotate(${secondDegrees}deg)`"
        ></div>
        <div id="pivot"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCSSFromStyles } from "@/components/Common/StyleEditor/utils";
import { clock_templates } from "./utils";
export default {
  name: "analog-clock",
  props: {
    clock: {
      type: Object,
    },
  },
  computed: {
    hourDegrees() {
      let hour = this.clock.hour ? this.clock.hour : 0;
      let minute = this.clock.minute ? this.clock.minute : 0;
      return 30 * hour + minute / 2;
    },
    minuteDegrees() {
      let minute = this.clock.minute ? this.clock.minute : 0;
      return 6 * minute;
    },
    secondDegrees() {
      let second = this.clock.second ? this.clock.second : 0;
      return 6 * second;
    },
    clockStyles() {
      let styles = {};
      if (this.clock.analog && this.clock.analog.styles) {
        styles = getCSSFromStyles(this.clock.analog.styles);
      }

      // Adding background based on selection
      if (this.clock.analog.template) {
        const current_clock_template = clock_templates.find((template) => {
          return template.id == this.clock.analog.template;
        });

        if (current_clock_template) {
          styles["background-image"] = `url('${current_clock_template.img}')`;
        }
      }
      return styles;
    },
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
#analog-clock {
  position: relative;
  background: url("https://cdn.hipwallpaper.com/i/18/18/bX1V9l.png") no-repeat;
  border: 10px solid #000;
  border-radius: 50%;
  background-size: 100%;
  border-width: 10px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

#hour,
#minute,
#second {
  position: absolute;
  background: black;
  border-radius: 10px;
  transform-origin: bottom;
}

#hour {
  width: 1.8%;
  height: 25%;
  top: 25%;
  left: 48.85%;
  opacity: 0.8;
}

#minute {
  width: 1.6%;
  height: 30%;
  top: 19%;
  left: 48.9%;
  opacity: 0.8;
}

#second {
  width: 1%;
  height: 40%;
  top: 9%;
  left: 49.25%;
  opacity: 0.8;
}
#pivot {
  width: 5%;
  height: 5%;
  border-radius: 50%;
  background: #000;
}
</style>